import PropTypes from 'prop-types';
import React from 'react';

import './index.scss';

import { CheckoutContainer } from './CheckoutContainer';

const MobileFirstCheckoutPage = ({
  includes_transport = false,
  tour_settings = {},
  is_booking_invoice = false,
  is_affiliate = false,
  is_unpaid_booking = false,
  is_pay_later_enabled = false,
  is_outside_pay_later_cutoff = false,
  is_rsvp_enabled = false,
  is_guest_info_collection_enabled = false,
  is_guest_of_guest_enabled = false,
  guest_of_guest_max_guests = 0,
  show_translate = false,
  is_live = false,
  ...props
}) => {
  return (
    <CheckoutContainer
      includes_transport={includes_transport}
      tour_settings={tour_settings}
      is_booking_invoice={is_booking_invoice}
      is_affiliate={is_affiliate}
      is_unpaid_booking={is_unpaid_booking}
      is_pay_later_enabled={is_pay_later_enabled}
      is_outside_pay_later_cutoff={is_outside_pay_later_cutoff}
      is_rsvp_enabled={is_rsvp_enabled}
      is_guest_info_collection_enabled={is_guest_info_collection_enabled}
      is_guest_of_guest_enabled={is_guest_of_guest_enabled}
      guest_of_guest_max_guests={guest_of_guest_max_guests}
      show_translate={show_translate}
      is_live={is_live}
      {...props}
    />
  );
};

MobileFirstCheckoutPage.displayName = 'MobileFirstCheckoutPage';

MobileFirstCheckoutPage.propTypes = {
  initial_summary_props: PropTypes.object.isRequired,
  initial_fully_discounted: PropTypes.bool.isRequired,
  initial_fields: PropTypes.object.isRequired,
  tour_id: PropTypes.number,
  booking_request_id: PropTypes.string.isRequired,
  includes_transport: PropTypes.bool,
  tour_settings: PropTypes.object,
  units: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  managed_account_token: PropTypes.string,
  is_ga4_enabled: PropTypes.bool,
  is_booking_invoice: PropTypes.bool,
  is_affiliate: PropTypes.bool,
  is_unpaid_booking: PropTypes.bool,
  is_pay_later_enabled: PropTypes.bool,
  is_outside_pay_later_cutoff: PropTypes.bool,
  is_rsvp_enabled: PropTypes.bool,
  is_guest_info_collection_enabled: PropTypes.bool,
  is_guest_of_guest_enabled: PropTypes.bool,
  guest_of_guest_max_guests: PropTypes.number,
  partner_info: PropTypes.object.isRequired,
  kiosk_setting: PropTypes.object,
  stripe_theme: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  will_expire_on: PropTypes.string,
  show_translate: PropTypes.bool,
  is_live: PropTypes.bool,
};

export default MobileFirstCheckoutPage;
